const CFG = window.DOPLINE_SEARCH || {};
const BASE = CFG.assetsBase || "";
const USE_MOCK = !!CFG.useMock;
// assetsVer is a hash derived from the Vite manifest on the PHP side.
// Appending it as ?ver forces browsers to reload IIFE scripts after each build.
const VER = CFG.assetsVer || "";

function loadScript(src) {
    return new Promise((resolve, reject) => {
        const s = document.createElement("script");
        s.src = VER ? `${src}?ver=${VER}` : src;
        s.async = true;
        s.onload = () => resolve();
        s.onerror = () => reject(new Error("Failed to load " + src));
        document.head.appendChild(s);
    });
}

export async function initHotelSearchScripts() {
    // 1) базовые утилиты и конфиг
    await loadScript(BASE + "/utils.js");
    await loadScript(BASE + "/config.js");

    // 2) mock-data если включено
    if (USE_MOCK) {
        await loadScript(BASE + "/mock-data.js");
    }

    // 3) остальное
    await loadScript(BASE + "/api.js");
    await loadScript(BASE + "/autocomplete.js");
    await loadScript(BASE + "/filters.js");
    await loadScript(BASE + "/datepicker.js");

    // 4) init всех форм на странице
    document.querySelectorAll("[data-dopline-search]").forEach((root) => {
        window.DoplineHS?.autocomplete?.initAutocomplete(root);
        window.DoplineHS?.filters?.initFilters(root);
        window.DoplineHS?.filters?.initGuestsPicker(root);
        window.DoplineHS?.datepicker?.initDatepicker(root);
    });

    window.DoplineHS?.filters?.initSearchSync();
}

